import React from "react";
import { TransactionDetailsType } from "../../../types/components";
import { ICONS } from "../../../constants/enums";

import Icon from "../../Common/Icon";

const TransactionDetailsHeader = ({ transactionDetails }: { transactionDetails: TransactionDetailsType }) => {
  const referenceNumberField = transactionDetails?.referenceNumberField;

  return (
    <header>
      <img src={transactionDetails?.logo} alt="Merchant Logo" />
      <p className="navy-blue bold font-size-xl spacing-top-tiny">{transactionDetails?.formattedAmount}</p>
      {referenceNumberField &&
        <>
          <p className="marengo-grey">{referenceNumberField.label}</p>
          <div className="flex-row justify-content-center align-items-center">
            <p className="bold abyss-blue">{referenceNumberField.formattedValue}</p>
            <button
              onClick={() => window.navigator.clipboard.writeText(referenceNumberField.formattedValue)}
              className="no-styling spacing-left-tiny"
              data-testid="copy-button"
            >
              <Icon icon={ICONS.COPY_BLUE} />
            </button>
          </div>
        </>
      }
    </header>
  );
}

export default TransactionDetailsHeader;